export interface PermissionModalText {
  readonly header: string;
  readonly message: string;
}

export interface PermissionModalButtons {
  readonly ok: string;
  readonly cancel: string;
}

// Lokalizacja wyłączona na poziomie systemu - kieruje do ustawień lokalizacji telefonu.
export const locationServicesOffText: PermissionModalText = {
  header: 'Brak dostępu do lokalizacji',
  message: 'Włącz lokalizację w ustawieniach telefonu, aby przeglądać gierki lub ustawić alerty o pobliskich gierkach'
};

// Aplikacja nie ma uprawnienia do lokalizacji - kieruje do ustawień aplikacji.
export const locationPermissionDeniedText: PermissionModalText = {
  header: 'Brak dostępu do lokalizacji',
  message: 'Zezwól aplikacji na dostęp do lokalizacji w ustawieniach, aby korzystać z gierek w pobliżu.'
};

export const notificationPermissionDeniedText: PermissionModalText = {
  header: 'Brak uprawnień do powiadomień w aplikacji',
  message: 'Nadaj uprawnienia do powiadomień aby otrzymywać powiadomienia'
};

// Uprawnienie jest, GPS działa, ale nie udało się złapać fixa - ustawienia nie pomogą.
export const locationUnavailableText: PermissionModalText = {
  header: 'Nie udało się pobrać lokalizacji',
  message: 'Nie udało się ustalić Twojej lokalizacji. Sprawdź sygnał GPS i spróbuj ponownie.'
};

export const permissionModalButtons: PermissionModalButtons = {
  ok: 'Włącz',
  cancel: 'Anuluj'
};
